<template>
  <div class="selectDealerBox">
    <div class="header">
      <div class="fvlr">
        <div></div>
        <div>可使用经销商</div>
        <div @click="close">
          <van-icon name="cross" />
        </div>
      </div>
      <div class="fvl searchBox">
        <div v-if="showCity" class="fvl" @click="selectCityFn">
          <van-icon size="20px" color="#3088c5" name="location-o" />
          <div class="result">{{ result.name || result }}</div>
        </div>
        <!-- <van-search v-model="searchVal" @update:model-value="onSearch" placeholder="请输入经销商名称或地址" /> -->
        <van-field class="mySearch" clearable v-model="searchVal" @update:model-value="onSearch" left-icon="search" placeholder="请输入经销商名称或地址" />
      </div>
    </div>
    <div class="selectDealer" :class="{ tyreSelectDealer: fromTyre }">
      <ul v-if="list.length">
        <li class="fvlr" :class="{ currentDealer: currentDealer.id === item.id }" v-for="item in list" :key="item.id" @click="selectFn(item)">
          <van-row gutter="8" justify="space-between">
            <van-col span="17">
              <div class="fhl left">
                <div class="fw">{{ item.name }}</div>
                <div class="bottom addressBox ellipsis ">
                  {{ item.address }}
                </div>
              </div>
            </van-col>
            <van-col span="6">
              <div class="activeWrap right">
                <div class="distance">
                  {{ item.distance || item.distance === 0 ? item.distance + 'km' : '定位失败' }}
                </div>
                <div v-if="isShowPhone" class="phoneBox" @click.stop>
                  <a :href="`tel:${item.tel}`">
                    <van-icon class="phone" name="phone" size="20" color="#3088c5" />
                  </a>
                </div>
              </div>
            </van-col>
          </van-row>
        </li>
      </ul>
      <div class="fc nodata" v-else>
        {{ fromTyre && !hasPosition && activeName === 'distance' ? '请开启定位功能' : loadData ? '' : '没有搜索到相应经销商' }}
      </div>
      <div v-if="loadData" class="fc"><van-loading type="spinner" color="#1989fa" /></div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, watch, onUnmounted, computed } from 'vue'
import { getUseDealersByloyaltyId, getUseDealersByloyaltyOrderId } from '@/api/plan'
import { getApplyDealerDetails, getShopApplyScopeDealerList, getApplyDealerList } from '@/api/directSales'
import { getContractApplyDealerList, getEwContractApplyDealerList, getEwCouponApplyDealerList } from '@/api/order'
import { useStore } from 'vuex'
import { getDistance } from '@/util'
import { showToast } from '@/util/couponCollection'
import { EWOrderTypeFlag, EWCouponType } from '@/util/order/staticConfig'

import _ from 'lodash'
export default {
  name: 'selectDealer',
  props: ['selectCity', 'showCity', 'showNum', 'fromTyre', 'isShowPhone', 'from'],
  setup(props, { emit }) {
    const store = useStore()
    let { selectCity, showNum, fromTyre, isShowPhone, from } = toRefs(props)
    let { formattedAddress, currentGoodsInfo, locationInfo, currentCity, useDealerInfo = {} } = store.state
    let { loyaltyId } = currentGoodsInfo
    let { position } = store.state
    const state = reactive({
      active: 0,
      position,
      searchVal: '',
      result: selectCity.value || currentCity || (locationInfo && locationInfo.city),
      searchQuery: '',
      list: [],
      listByDistance: [],
      listBySales: [],
      allList: [],
      ProvinceCity: [],
      loyaltyId,
      currentDealer: loyaltyId ? useDealerInfo : {},
      fromTyre,
      from,
      isShowPhone,
      formattedAddress,
      activeName: 'distance',
      showLoading: false,
      loadData: false,
      hasPosition: true,
      Reflect
    })
    let address = computed(() => {
      return store.state.formattedAddress
    })
    let city = computed(() => {
      let { locationInfo, currentCity } = store.state
      return selectCity.value || currentCity || (locationInfo && locationInfo.city)
    })
    let getDealersFn = async val => {
      let { position, loyaltyApplyDealerParam } = store.state
      let { lat, lng } = position
      // console.log('getDealersFn---loyaltyApplyDealerParam----', loyaltyApplyDealerParam)
      let { loyaltyId = '', gsCode = '', sign = '', orderId, productId = '', skuId = '', orderTypeFlag, couponType } = loyaltyApplyDealerParam
      let getUseDealersByApplyDealerParamFn = getUseDealersByloyaltyId
      let dearParams = {
        cityName: state.result.name || state.result,
        keyword: val,
        latitude: lat,
        longitude: lng,
        loyaltyId,
        gsCode,
        pageNo: '1',
        pageSize: '10000'
      }
      state.list = state.allList = []
      state.loadData = true
      //getUseDealersByloyaltyOrderId
      if (sign === 'couponTypeList') {
        // dearParams.sign = 'couponTypeList'
        dearParams.couponId = productId
        if (couponType === EWCouponType) {
          dearParams.cityName = ''
        }
        getUseDealersByApplyDealerParamFn = couponType === EWCouponType ? getEwCouponApplyDealerList : getApplyDealerDetails
      }
      if (sign === 'loyaltyCouponTypeList') {
        dearParams.orderId = orderId
        getUseDealersByApplyDealerParamFn = getUseDealersByloyaltyOrderId
      }
      if (sign === 'shopDetail') {
        dearParams.skuId = skuId
        getUseDealersByApplyDealerParamFn = getShopApplyScopeDealerList
      }
      if (sign === 'ewShopDetail') {
        dearParams = {
          cityName: '',
          keyword: val,
          latitude: lat,
          longitude: lng,
          gsCode,
          skuId
        }
        getUseDealersByApplyDealerParamFn = getApplyDealerList
      }
      if (sign === 'contractOrder') {
        dearParams.isExport = 0
        dearParams.orderId = orderId
        dearParams.cityName = ''
        getUseDealersByApplyDealerParamFn = orderTypeFlag === EWOrderTypeFlag ? getEwContractApplyDealerList : getContractApplyDealerList
      }
      if (sign === 'loyaltyOrder') {
        dearParams.orderId = orderId
        getUseDealersByApplyDealerParamFn = getUseDealersByloyaltyOrderId
      }
      try {
        let data = await getUseDealersByApplyDealerParamFn(dearParams)
        let list = (data && data.list) || []
        if (sign && ['contractOrder', 'couponTypeList', 'shopDetail'].includes(sign)) {
          list = data.records || data || []
        } else if (sign === 'ewShopDetail' || orderTypeFlag === EWOrderTypeFlag) {
          list = data
        }
        list = list && list.length ? list : []
        state.list = state.allList = getDistanceFn(list, sign === 'ewShopDetail' || orderTypeFlag === EWOrderTypeFlag || couponType === EWCouponType)
      } catch (error) {
        state.list = state.allList = []
        showToast(error.message, '数据请求失败')
      } finally {
        state.loadData = false
      }
    }
    const getDistanceFn = (list, isEWShopDetail) => {
      list.map(item => {
        item.distance = getDistance(item.distance, isEWShopDetail)
        let _gsCode = item.gs_code || item.gsCode
        item.gs_code = item.gsCode = _gsCode
        return item
      })
      return list
    }

    watch(
      () => selectCity.value,
      n => {
        state.result = n
        state.searchVal = ''
        console.log('selectCity----------')
        getDealersFn()
      }
    )
    watch(
      () => showNum.value,
      () => {
        let { loyaltyId } = store.state.currentGoodsInfo
        state.currentDealer = store.state.useDealerInfo || {}
        state.loyaltyId = loyaltyId
      }
    )
    watch(
      () => store.state.position,
      () => {
        // state.fromTyre && getTyreDealerList()
      }
    )
    watch(
      () => store.state.formattedAddress,
      n => {
        state.formattedAddress = n
        state.showLoading = false
      }
    )
    watch(
      () => store.state.loyaltyApplyDealerParam,
      () => {
        // console.log('loyaltyApplyDealerParam----------', n)
        getDealersFn()
      }
    )
    watch(
      () => state.activeName,
      n => {
        state.list = n === 'distance' ? state.listByDistance : state.listBySales
      }
    )
    watch(
      () => store.state.carId,
      () => {
        // if (n !== o) getOabDealerList()
      }
    )
    let onSearch = _.debounce(async val => {
      console.log('onSearch----------')
      getDealersFn(val)
    }, 200)
    let relocation = () => {
      state.showLoading = true
      store.dispatch('getLocation')
      setTimeout(() => {
        state.showLoading = false
      }, 5000)
    }
    let selectCityFn = () => {
      emit('selectCityFn')
    }
    let close = () => {
      emit('selectResultFn')
    }
    // const getUseDealersByloyaltyIdFn = async () => {
    // let res = await getUseDealersByloyaltyId()
    // console.log('getUseDealersByloyaltyIdFn-res', res)
    // }
    let selectFn = () => {
      emit('selectResultFn')
      // getUseDealersByloyaltyIdFn()
    }
    onMounted(async () => {
      state.result = city.value
      state.formattedAddress = address.value
      console.log('onMounted----------')
      getDealersFn()
    })
    onUnmounted(() => {
      onSearch.cancel()
    })
    return {
      ...toRefs(state),
      close,
      selectFn,
      onSearch,
      selectCityFn,
      relocation
    }
  }
}
</script>

<style lang="scss" scoped>
.nodata {
  margin-top: 65px;
}
.cb {
  width: 15px;
  height: 15px;
  margin-right: 4px;
}
.address {
  margin-right: 5px;
}
.currentAdressFlag {
  font-size: 12px;
  color: #999;
  margin-bottom: 8px;
}
.currentAdress {
  font-size: 14px;
  color: #333333;
  span {
    font-size: 12px;
    color: #666;
  }
}
.selectDealerBox {
  height: 100%;
  position: relative;
  text-align: left;
  .selectDealer {
    width: 100%;
    padding: 104px 22px 0;
    position: absolute;
    top: 50px;
    margin-top: -50px;
    height: 100%;
    overflow-y: scroll;
    box-sizing: border-box;
    .right {
      text-align: center;
    }
    .distance {
      line-height: 1.6;
    }
  }
  .tyreSelectDealer {
    padding-top: 191px;
    ul {
      margin-top: 20px;
    }
  }
  .header {
    font-size: 15px;
    padding: 15px 22px;
    font-weight: bold;
    position: absolute;
    top: 0;
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    z-index: 10;
  }
  .searchBox {
    font-size: 14px;
  }
  .result {
    width: 60px;
    margin-left: 5px;
  }
  .van-search {
    padding-right: 0;
    width: 100%;
    font-size: 12px;
  }
  .van-field__control {
    width: 200px;
  }
  li {
    padding: 16px 0;
    border-bottom: 1px solid rgb(238, 238, 238);
    > div {
      width: 100%;
    }
  }
  .left {
    text-align: left;
  }
  .bottom {
    margin-top: 9px;
  }
  .activeBox {
    padding: 2px 5px;
    border-radius: 18px;
    border: 1px solid #666666;
  }
  .addressBox {
    width: 100%;
    color: #666666;
  }
  .active {
    color: #3088c5;
    border-color: #3088c5;
  }
  .currentDealer div {
    color: #3088c5;
    .activeBox {
      border-color: #3088c5;
    }
  }
  .hidden {
    // visibility: hidden;
    display: none;
  }
  .activeWrap {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}
.fw {
  color: #333333;
  font-size: 14px;
}
.sales {
  font-size: 0.34667rem;
  color: #3088c5;
  margin-top: 10px;
}
.phoneBox {
  display: inline-block;
  width: 30px;
  height: 26px;
  transform: rotate(-90deg);
  vertical-align: bottom;
}
:deep(.van-tabs__line) {
  width: 98px;
  background-color: #3088c5;
}
:deep(.van-tab--active) {
  color: #3088c5;
  font-size: 14px;
  font-weight: 600;
}
</style>
